import axios from 'axios';
import { performLogout } from './utils/logout';
import {store} from './store';

export const API_BASE = "https://api.projectivetech.com";
// export const API_BASE = "http://127.0.0.1:8000";  // local dev

const axiosInstance = axios.create({
  baseURL: API_BASE,
});

// ── Axios interceptor: attach token to every axiosInstance call ───────────────
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && !config.skipAuth) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  delete config.skipAuth;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.message;
    if (message === 'You have been logged out due to another login.') {
      const { store } = require('./store');
      const { performLogout } = require('./utils/logout');
      performLogout(store.dispatch, {
        push: (path) => (window.location.href = path),
      });
    }
    return Promise.reject(error);
  }
);

// ── Global fetch patch: attach token to every raw fetch() hitting our API ────
// This covers all components that use fetch() directly instead of axiosInstance.
// Calls to third-party URLs (S3, bridgestone, etc.) are left untouched.
(function patchFetch() {
  const _fetch = window.fetch.bind(window);

  const isOwnApi = (url) => {
    if (!url || typeof url !== 'string') return false;
    return (
      url.includes('api.projectivetech.com') ||
      url.startsWith('/')               ||
      url.startsWith(API_BASE)
    );
  };

  window.fetch = function authFetch(url, options = {}) {
    if (isOwnApi(String(url))) {
      const token = localStorage.getItem('token');
      if (token) {
        options = {
          ...options,
          headers: {
            ...options.headers,
            Authorization: `Bearer ${token}`,
          },
        };
      }
    }
    return _fetch(url, options);
  };
})();

export default axiosInstance;
